
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
} from "@mui/material";
import { axiosGetCall } from "src/services/apisCall";

const columns = [
  { id: "roomId", label: "RoomID" },
  { id: "displayName", label: "Name" },
  { id: "duration", label: "Duration" },
  { id: "joinedAt", label: "JoinedAt" },
  { id: "lastUpdatedAt", label: "Leave" },
];

const ReportInfo = ({ roomId, startDate, endDate, open, onClose }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const formatDisplayDate = (value) => {
    if (!value) return "-";
    const date = new Date(value);
    if (isNaN(date)) return value;
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${mm}-${dd}-${yyyy}`;
  };

  const fetchInfo = async () => {
    setLoading(true);
    try {
      const { result } = await axiosGetCall("webinarMeetParticipants", {
        roomId,
        startDate,
        endDate
      });

      setData(result || []);
    } catch (err) {
      console.error("Error fetching more info", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open && roomId && startDate && endDate) fetchInfo();
  }, [open, roomId, startDate, endDate]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "80vw",
          height: "80vh",
        },
      }}
    >
      <DialogTitle>Meeting Details</DialogTitle>
      <DialogContent dividers sx={{ overflow: "auto" }}>
        {loading ? (
          <CircularProgress />
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                {columns?.map((column) => (
                  <TableCell key={column.id}>{column.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={columns.length}>No Data</TableCell>
                </TableRow>
              ) : (
                data?.map((item, idx) => (
                  <TableRow key={idx}>
                    {columns?.map((column) => {
                      let value = item[column.id];
                      if (column.id === "joinedAt" || column.id === "lastUpdatedAt") {
                        value = formatDisplayDate(value);
                      }
                      return (
                        <TableCell key={column.id}>
                          {value === 0 ? 0 : value || "-"}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ReportInfo;

